/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

require('./src/styles/main.css');

let lastOpenAIPageViewKey;

const getOpenAIPageViewData = (location) => {
  const pagePath = `${location.pathname}${location.search}` || '/';

  return {
    type: 'contents',
    contents: [
      {
        id: pagePath,
        name: document.title || pagePath,
        content_type: 'page',
      },
    ],
  };
};

const measureOpenAIPageView = (location) => {
  if (typeof window.oaiq !== 'function') {
    return;
  }

  const pageViewKey = `${location.pathname}${location.search}`;

  if (pageViewKey === lastOpenAIPageViewKey || pageViewKey === window.revenueCatOpenAIPageViewKey) {
    return;
  }

  lastOpenAIPageViewKey = pageViewKey;
  window.revenueCatOpenAIPageViewKey = pageViewKey;
  window.oaiq('measure', 'page_viewed', getOpenAIPageViewData(location));
};

exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.state && location.state.preventScroll === true) {
    return false;
  }

  if (location.hash) {
    window.history.scrollRestoration = 'auto';
    return true;
  }

  // Fix for Gatsby 5 issue with scroll-behavior - https://github.com/gatsbyjs/gatsby/issues/38201
  window.history.scrollRestoration = 'manual';

  const currentPosition = getSavedScrollPosition(location, location.key);
  const top = currentPosition ? currentPosition[1] : 0;

  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      try {
        window.scrollTo({ top, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(top);
      }
    });
  }, 0);

  return false;
};

exports.onRouteUpdate = ({ location }) => {
  measureOpenAIPageView(location);

  try {
    window.HubSpotConversations.widget.refresh();
  } catch (e) {
    console.warn('Could not refresh Hubspot Conversations widget');
  }
};

// This fixes a problem where the /docs/* pages redirects to a link with a trailing slash
exports.onInitialClientRender = () => {
  measureOpenAIPageView(window.location);

  const handleBodyClick = (event) => {
    const targetLink = event.target.closest('a');

    if (targetLink && targetLink.origin === window.location.origin) {
      const path = targetLink.getAttribute('href');

      if (path.includes('/docs/')) {
        event.preventDefault();
        window.location.href = path;
      }
    }
  };

  document.body.addEventListener('click', handleBodyClick);
};
